<template>
  <router-link :to="instance.url">
    <div class="card">
      <div class="card-image">
        <figure class="b-image-wrapper image is-1by1">
          <picture>
            <source :srcset="instance.picture">
            <p>
              <img class="has-ratio" :src="instance.picture" :alt="instance.fullName">
            </p>
          </picture>
        </figure>
      </div>
      <div class="card-content">
        <div class="content">
          <h3>{{ instance.fullName }}</h3>
          <p class="is-size-6 has-text-black">
            {{ instance.summary }}
            <router-link :to="instance.url">[...]</router-link>
          </p>

        </div>
      </div>
      <footer class="card-footer">
        <time v-if="instance.kidnapping.fechades" :datetime="instance.kidnapping.fechades" title="Fecha de secuestro" class="card-footer-item">{{ instance.kidnapping.fechades | formatDate }}</time>
        <span v-if="instance.kidnapping.edad" class="card-footer-item">{{ instance.kidnapping.edad }} años</span>
      </footer>
    </div>
  </router-link>
</template>
<script>
export default {
  props: ["instance"],
};
</script>
